module.exports = __webpack_public_path__ + "img/g3.55e3f360.png";